/**
 * Copy commercial Inclus / Plus — 2 offres visibles.
 * Premium reste en architecture (enum) mais n’est pas commercialisé ici.
 */

export const COMMERCIAL_TIERS = ['INCLUS', 'PLUS'];

export const OFFER_BENEFITS = {
  INCLUS: {
    label: 'Inclus',
    tagline: 'Communiquez avec vos clients',
    bullets: [
      '3 campagnes email par mois',
      '5 campagnes In-App par mois',
      '200 destinataires max par email',
    ],
  },
  PLUS: {
    label: 'Plus',
    tagline: 'Développez votre activité',
    bullets: [
      '6 campagnes email par mois',
      '10 campagnes In-App par mois',
      '2 000 destinataires max par email',
    ],
  },
};

/** Libellé secondaire d’usage — jamais le pitch principal */
export function formatOfferCapacityHint(caps = {}, remaining = null) {
  const emailMax = caps.emailCampaignsPerMonth;
  const inAppMax = caps.inAppCampaignsPerMonth;
  if (typeof emailMax !== 'number' && typeof inAppMax !== 'number') return null;

  if (remaining && typeof remaining === 'object') {
    const parts = [];
    if (typeof remaining.email === 'number') {
      parts.push(
        `${remaining.email} email restante${remaining.email > 1 ? 's' : ''}`
      );
    }
    if (typeof remaining.inApp === 'number') {
      parts.push(
        `${remaining.inApp} In-App restante${remaining.inApp > 1 ? 's' : ''}`
      );
    }
    return parts.length ? `${parts.join(' · ')} ce mois-ci` : null;
  }

  const parts = [];
  if (typeof emailMax === 'number') {
    parts.push(`${emailMax} email${emailMax > 1 ? 's' : ''}`);
  }
  if (typeof inAppMax === 'number') {
    parts.push(`${inAppMax} In-App`);
  }
  return parts.length ? `Jusqu’à ${parts.join(' et ')} ce mois-ci` : null;
}

export function contactUpgradeHref() {
  return 'mailto:support@clickorico.fr?subject=Evoluer%20vers%20l%27offre%20Plus%20Communication';
}
